import { ref } from 'vue'

const showPopUp = ref(false)

export function usePopUp() {
  const openPopUp = () => {
    showPopUp.value = true
  }

  const closePopUp = () => {
    showPopUp.value = false
  }

  return {
    showPopUp,
    openPopUp,
    closePopUp,
  }
}
